(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["es-product"] && !Shopify.designMode) return;
  try {
    
  class EsGallery extends HTMLElement {
    connectedCallback() {
      this.main = this.querySelector('[data-es-main]');
      this.thumbs = this.querySelectorAll('[data-es-thumb]');
      this.stickyImg = document.querySelector('[data-es-sticky-img]');
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-es-thumb]');
        if (!btn || !this.main) return;
        this.main.src = btn.dataset.full;
        if (btn.dataset.srcset) this.main.srcset = btn.dataset.srcset;
        if (this.stickyImg && btn.dataset.full) { this.stickyImg.src = btn.dataset.full; this.stickyImg.removeAttribute('srcset'); }
        this.thumbs.forEach((t) => {
          t.classList.toggle('is-active', t === btn);
          if (t === btn) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
        });
      });
    }
  }
  if (!customElements.get('es-gallery')) customElements.define('es-gallery', EsGallery);

  class EsTierCards extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.idInput = this.form && this.form.querySelector('[data-es-variant-id]');
      this.qtyInput = this.form && this.form.querySelector('[data-es-qty-input]');
      this.priceEl = document.querySelector('[data-es-price]');
      this.stickyPriceEl = document.querySelector('[data-es-sticky-price]');
      this.addEventListener('change', (e) => {
        const radio = e.target.closest('input[type="radio"]');
        if (!radio) return;
        if (this.idInput) this.idInput.value = radio.value;
        if (this.qtyInput && radio.dataset.qty) this.qtyInput.value = radio.dataset.qty;
        this.querySelectorAll('.es-pdp__card').forEach((c) => c.classList.toggle('is-selected', c.contains(radio)));
        const now = '<span class="es-pdp__price-now">' + radio.dataset.now + '</span>';
        const was = radio.dataset.was ? '<s class="es-pdp__price-was">' + radio.dataset.was + '</s>' : '';
        if (this.priceEl) this.priceEl.innerHTML = now + was;
        if (this.stickyPriceEl) this.stickyPriceEl.innerHTML = now + was;
      });
    }
  }
  if (!customElements.get('es-tier-cards')) customElements.define('es-tier-cards', EsTierCards);

  (function () {
    const bar = document.querySelector('[data-es-stickybar]');
    const trigger = document.querySelector('.es-pdp__cards') || document.querySelector('.es-pdp__actions');
    if (bar && trigger && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
          bar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        });
      }, { threshold: 0 });
      io.observe(trigger);
    }

    const buyBtn = bar && bar.querySelector('[data-es-sticky-buy]');
    if (buyBtn) {
      buyBtn.addEventListener('click', async () => {
        const form = document.getElementById('es-product-form');
        if (!form) return;
        const idEl = form.querySelector('[data-es-variant-id]');
        const qtyEl = form.querySelector('[name="quantity"]');
        const id = idEl && idEl.value;
        if (!id) return;
        const quantity = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
        buyBtn.disabled = true;
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: id, quantity: quantity })
          });
          if (!res.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        } catch (e) {
          buyBtn.disabled = false;
        }
      });
    }
  })();

  // Quantity stepper next to Add to cart. On single-variant products the displayed price
  // is the order total (unit × qty) so the shipping line under it stays true; at qty 1 the
  // server-rendered price (incl. any compare-at strike) is restored. Multi-variant products
  // show the selected variant's price and the stepper only sets the quantity.
  (function () {
    const form = document.getElementById('es-product-form');
    if (!form) return;
    const qtyInput = form.querySelector('[data-es-qty-input]');
    const stepper = form.querySelector('[data-es-qty-stepper]');
    if (!qtyInput || !stepper) return;
    const unitCents = parseInt(stepper.dataset.esUnitPrice, 10) || 0;
    const priceEl = document.querySelector('[data-es-price]');
    const stickyPriceEl = document.querySelector('[data-es-sticky-price]');
    const initialPrice = priceEl ? priceEl.innerHTML : '';
    const initialSticky = stickyPriceEl ? stickyPriceEl.innerHTML : '';
    const nowEl = priceEl && priceEl.querySelector('.es-pdp__price-now');
    const prefixMatch = nowEl && (nowEl.textContent || '').match(/^[^0-9]*/);
    const prefix = prefixMatch ? prefixMatch[0] : '$';
    function money(cents) { return prefix + (cents / 100).toFixed(2); }
    function renderPrice(q) {
      if (!unitCents) return;
      if (q === 1) {
        if (priceEl) priceEl.innerHTML = initialPrice;
        if (stickyPriceEl) stickyPriceEl.innerHTML = initialSticky;
        return;
      }
      const html = '<span class="es-pdp__price-now">' + money(unitCents * q) + '</span>';
      if (priceEl) priceEl.innerHTML = html;
      if (stickyPriceEl) stickyPriceEl.innerHTML = html;
    }
    function readQty() { let v = parseInt(qtyInput.value, 10); if (isNaN(v) || v < 1) v = 1; return v; }
    function applyQty(q) { qtyInput.value = q; renderPrice(q); }

    stepper.querySelector('[data-es-qty-down]').addEventListener('click', function () { applyQty(Math.max(1, readQty() - 1)); });
    stepper.querySelector('[data-es-qty-up]').addEventListener('click', function () { applyQty(readQty() + 1); });
    qtyInput.addEventListener('change', function () { applyQty(readQty()); });
  })();

  // Shipping line under the price: follows whatever order total the price element
  // currently shows (variant price, or qty × unit price), so it stays true for any
  // path that re-renders the price — variant cards or the stepper.
  (function () {
    const line = document.querySelector('[data-es-shipline]');
    const priceEl = document.querySelector('[data-es-price]');
    if (!line || !priceEl) return;
    const threshold = parseInt(line.dataset.threshold, 10) || 9900;
    const freeEl = line.querySelector('[data-es-ship-free]');
    const paidEl = line.querySelector('[data-es-ship-paid]');
    const gapEl = line.querySelector('[data-es-ship-gap]');
    function update() {
      const now = priceEl.querySelector('.es-pdp__price-now');
      if (!now) return;
      const text = now.textContent || '';
      const cents = Math.round(parseFloat(text.replace(/[^0-9.]/g, '')) * 100);
      if (isNaN(cents)) return;
      const prefix = (text.match(/^[^0-9]*/) || [''])[0];
      const free = cents >= threshold;
      if (freeEl) freeEl.hidden = !free;
      if (paidEl) paidEl.hidden = free;
      if (!free && gapEl) gapEl.textContent = prefix + ((threshold - cents) / 100).toFixed(2);
      line.classList.toggle('is-free', free);
    }
    new MutationObserver(update).observe(priceEl, { childList: true, subtree: true, characterData: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["es-related-products"] && !Shopify.designMode) return;
  try {
    
  class EsRelatedProducts extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url || this.dataset.loaded) return;
      this.dataset.loaded = 'true';
      fetch(url)
        .then((r) => {
          if (!r.ok) throw new Error('recommendations failed');
          return r.text();
        })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const fresh = doc.querySelector('es-related-products');
          if (fresh && fresh.querySelector('.es-related__grid')) {
            this.innerHTML = fresh.innerHTML;
            const sec = this.closest('.es-related');
            if (sec) sec.removeAttribute('hidden');
          }
        })
        .catch(() => {});
    }
  }
  if (!customElements.get('es-related-products')) customElements.define('es-related-products', EsRelatedProducts);

  } catch(e) { console.error(e); }
})();
})();
